import React, {FC, useState} from "react";
import shopApi from "../../api/shop";
import {CustomTextField} from "../../atoms";
import cls from "./account.module.scss"
import {spaceToUpperCaseConvertor} from "../../services/utils";
import PageHeader from "../shared/PageHeader";
import {TranslationsType} from "../../types/homePageTypes";

interface IProps {
    breadcrumb: Array<{ title: string; url: string }>;
    translationsData: TranslationsType;
    dbName: string
}

const AccountForgotPassword: FC<IProps> = ({breadcrumb, translationsData, dbName}) => {
    const [input, setInput] = useState<string | undefined>();
    const [errors, setErrors] = useState("");
    const [note, setNote] = useState({
        success: "",
        danger: ""
    });
    const handleChange = (e: React.FormEvent<HTMLInputElement>) => setInput((e.target as HTMLInputElement).value);

    const sedForgot = (event: { preventDefault: () => void; }) => {
        event.preventDefault();
        if (input) {
            shopApi.getForgetPassword(input)
                .then((res) => {
                    if (res === "Email has been sent successfully") {
                        setErrors("")
                        setNote({
                            success: res,
                            danger: ""
                        });
                    } else {
                        setNote({
                            success: "",
                            danger: res
                        })
                    }
                })
                .catch(() => setErrors("the_email_must_be_a_valid_email_address."));
        } else setErrors("the_email_field_is_required")
    };

    return (
        <div className="page">
            <PageHeader dbName={dbName} breadcrumb={breadcrumb}/>
            <div className={cls["page__forgot_password"]}>
                <div className="container">
                    <div className={cls["card-wrapper"]}>
                        <div className={cls.card}>
                            <div className={cls["card-body"]}>
                                <h1 className={cls["card-title"]}>
                                    {translationsData.ForgotPassword}
                                </h1>
                                <form>
                                    <div className={cls["signUp-position-relative"]}>
                                        <CustomTextField
                                            value={translationsData.Email}
                                            type="email"
                                            name="email"
                                            inpValue={input}
                                            handleChange={handleChange}
                                        />
                                        <div className="alert alert-danger">
                                            {errors && (
                                                <div className="alert-danger">
                                                    {translationsData[spaceToUpperCaseConvertor(errors)]}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <button
                                        type="submit"
                                        onClick={sedForgot}
                                        className={`btn btn-lg btn-orange ${cls["login-button"]} ${cls["sbm_button"]}`}
                                    >
                                        {translationsData.Send}
                                    </button>
                                    {
                                        note.danger ?
                                            <div
                                                className="alert"
                                                style={{
                                                    marginTop: "20px",
                                                    borderRadius: "4px",
                                                    background: "#ffb8b8",
                                                    color: "#473333"
                                                }}
                                            >
                                                {translationsData[spaceToUpperCaseConvertor(errors)]}
                                            </div>
                                            :
                                            note.success &&
                                            <div
                                                className="alert alert-success"
                                                style={{marginTop: "20px", borderRadius: "4px"}}
                                            >
                                                {translationsData.EmailHasBeenSentSuccessfully}
                                            </div>
                                    }
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AccountForgotPassword